/* i18n */
import { useI18n } from 'vue-i18n'

import { routeList } from '@/router/helpers/routes'

/* Mapping Category icon  */
export const categoryIconMapper = (categoryId, darkMode) => {
    let iconPath = '/services/OtherServices'

    const categoryIcons = {
        TV: '/services/TvInternetTelcom',
        tvInternetTelcom: '/services/TvInternetTelcom',
        publicServices: '/services/PublicServices',
        travelServices: '/services/Travel',
        education: '/services/Education',
        housing: '/services/Housing',
        insurance: '/services/BankAssurance',
        higherEducation: '/services/University',
        otherServices: '/services/OtherServices'
    }

    if (categoryIcons[categoryId]) iconPath = categoryIcons[categoryId]

    if (darkMode) return `${iconPath}-dark-mode`
    return iconPath
}

export const categoryCardIllustrationMapper = categoryId => {
    const categoryIcons = {
        TV: 'payments-tv-net-telecom',
        tvInternetTelcom: 'payments-tv-net-telecom',
        publicServices: 'payments-state',
        taxes: 'payments-state',
        travelServices: 'payments-turism',
        education: 'payments-education-books',
        housing: 'payments-habitation',
        insurance: 'bankassurance-health',
        higherEducation: 'payments-education',
        otherServices: 'payments-services'
    }

    return categoryIcons[categoryId] || null
}

/* Mapping Payments Flows Route by paymentFlow or paymentTypeId
@identifier { string, number } - payment flow or paymentTypeId
@returns { string } - route name for redirect
*/
export const paymentsFlowsRoute = identifier => {
    const route = {
        /* Payment Flows Names */
        emis_special_service: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
        emis_special: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
        emis_reference: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        emis_service: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        emis_voucher: routeList.PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_NAME,
        emis_refill: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFILL_NAME,
        unitel_agents: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
        minfin_bai: routeList.PAYMENTS_SERVICES_FLOW_MINFIN_NAME,
        unitel: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
        cajueiro: routeList.PAYMENTS_SERVICES_FLOW_CAJUEIRO_NAME,
        dstv: routeList.PAYMENTS_SERVICES_FLOW_DSTV_NAME,
        movicel: routeList.PAYMENTS_SERVICES_FLOW_MOVICEL_NAME,
        /* Payment Type Ids */
        19004: routeList.PAYMENTS_SERVICES_FLOW_EMIS_SPECIAL_NAME,
        19001: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        35021: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFERENCE_NAME,
        35023: routeList.PAYMENTS_SERVICES_FLOW_EMIS_VOUCHER_NAME,
        35018: routeList.PAYMENTS_SERVICES_FLOW_EMIS_REFILL_NAME,
        35004: routeList.PAYMENTS_SERVICES_FLOW_UNITEL_NAME,
        35002: routeList.PAYMENTS_SERVICES_FLOW_CAJUEIRO_NAME,
        35008: routeList.PAYMENTS_SERVICES_FLOW_DSTV_NAME
        /* TO DO: */
        /* On the mapper getFavoriteRoute, we have more cases that are not above:
        19002, 19003, 21002, 22028, 22031, 31002 */
    }

    return route[identifier]
}

export const parseOperatorIdForFavoriteTab = identifier => {
    const route = {
        /* Payment Type Ids */
        19004: 174,
        19001: 202,
        35021: 202,
        35023: 223,
        35018: 223,
        35004: 174,
        35002: 133,
        35008: 146
        /* TO DO: */
        /* On the mapper getFavoriteRoute, we have more cases that are not above:
        19002, 19003, 21002, 22028, 22031, 31002 */
    }

    return route[identifier]
}
